import {
  resolveSidebarCollapsed,
  resolveSidebarUserPref,
  syncSidebarCollapsedDomAttr,
  SIDEBAR_COOKIE_OPTIONS,
  SIDEBAR_STATE_KEY,
  SIDEBAR_USER_PREF_COOKIE,
} from '~/utils/dashboard-sidebar-state'

/**
 * 每次导航（含 SSR 首屏）按 Cookie 恢复侧栏偏好，避免定价页刷新丢 `expanded`。
 */
export default defineNuxtRouteMiddleware((to) => {
  const sidebarUserPref = useCookie(SIDEBAR_USER_PREF_COOKIE, {
    default: () => '',
    ...SIDEBAR_COOKIE_OPTIONS,
    watch: false,
  })

  let cookieHeader = ''
  if (import.meta.server) {
    cookieHeader = useRequestHeaders(['cookie']).cookie || ''
  } else if (typeof document !== 'undefined') {
    cookieHeader = document.cookie
  }

  const pref = resolveSidebarUserPref(cookieHeader, sidebarUserPref.value)
  if (pref && sidebarUserPref.value !== pref) {
    sidebarUserPref.value = pref
  }

  const resolved = resolveSidebarCollapsed(to, pref)
  const sidebarCollapsed = useState(SIDEBAR_STATE_KEY)
  sidebarCollapsed.value = resolved

  if (import.meta.client) {
    syncSidebarCollapsedDomAttr(resolved)
  }
})
